import React, {useEffect, useState} from 'react';
import API from "libs/api";
import { Button, Modal } from 'semantic-ui-react';
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L, { divIcon, LatLng } from 'leaflet';
import { CHIPS, INPUT } from "components/cmp_form/cmp_form";
import PROCESSING from "components/cmp_processing/cmp_processing";
import CMP_CONFIRMATION from "components/cmp_confirmation/cmp_confirmation";
import ICON from 'components/cmp_icon/cmp_icon';
import MDL_LATLON from './../mdl_latlon/mdl_latlon';

import './mdl_location.css';
import 'leaflet/dist/leaflet.css';

export default function MDL_LOCATION({ onClose, onOpen, onRefresh, var_locationID, var_providerID }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [var_data, set_data] = useState([]);
    const [var_processing, set_processing] = useState('inactive');
    const [var_can_process, set_can_process] = useState(true);

    //  delete provider
    const [ var_deleteLocation_open, set_deleteLocation_open ] = useState(false);
    const [ var_deleteStatus, set_deleteStatus ] = useState('inactive')

    //  geapify modal
    const [var_latlon_open, set_latlon_open] = useState(false);

    //  map marker
    const var_marker = divIcon({
        html: `
      <svg width="100%" height="100%" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(0, 0)">
          <path d="M40,18c0,11-16,27-16,27 S8,29,8,18C8,7.875,16.268,2,24,2S40,7.875,40,18z" fill="#ffffff" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="8%" strokeLinejoin="round" />
          <circle cx="24" cy="18" r="5" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="8%" strokeLinejoin="round" />
        </g>
      </svg>`,
        className: "svg-icon",
        iconSize: [32, 32],
        iconAnchor: [16, 32]
    })



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        set_processing('inactive');
        set_can_process(true);
        if (var_locationID !== '' && var_locationID !== 'ADD') {
            get_location();
        } else {
            let data = [];
            data.reviewed = 'YES';
            data.online = 'NO';
            data.cityonly = 'NO';
            data.provider_id = var_providerID;
            set_data(data);
        }
    }, [onOpen])



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_location() {

        set_data([]);
        set_can_process(false);
        set_processing('processing');

        try {
            let results = await API_get_location();

            //  set data
            set_data(results === undefined ? [] : results);

            set_processing('inactive');
            set_can_process(true);
        } catch (e) {
            set_processing('error');
        }
    }

    async function post_location() {

        set_can_process(false);
        set_processing('processing');

        try {
            await API_post_location();

            onRefresh()
            onClose()

        } catch (e) {
            set_processing('error');
        }
    }

    async function put_location() {

        set_can_process(false);
        set_processing('processing');

        try {
            await API_put_location();

            onRefresh()
            onClose()

        } catch (e) {
            set_processing('error');
        }
    }

    async function delete_location() {

        set_deleteStatus('processing');

        try {
            await API_delete_location();

            set_deleteLocation_open(false);
            onRefresh();
            onClose();

        } catch (e) {
            set_deleteStatus('error');
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_location() {
        return API.get('admin-providers', '/get-location/' + var_locationID);
    }

    function API_post_location() {
        return API.post('admin-providers', '/post-location/', {body: var_data});
    }

    function API_put_location() {
        return API.put('admin-providers', '/put-location/', {body: var_data});
    }

    function API_delete_location() {
        return API.del('admin-providers', '/delete-location/' + var_locationID);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onChange_reviewed(event) {
        let data = {...var_data};
        data.reviewed = event;
        set_data(data);
    }

    function onChange_online(event) {
        let data = {...var_data};
        data.reviewed = 'YES';
        data.online = event;
        data.cityonly = null;
        data.address = null;
        data.city = null;
        data.state = null;
        data.country = null;
        data.lat = null;
        data.lon = null;
        data.geoapify_confidence = null;
        set_data(data);
    }

    function onChange_cityOnly(event) {
        let data = {...var_data};
        data.reviewed = 'YES';
        data.online = null;
        data.cityonly = event;
        data.address = null;
        set_data(data);
    }

    function onChange_location(event) {
        let data = {...var_data};
        data[event.target.name] = event.target.value;
        set_data(data);
    }

    function onClick_add() {
        if (var_can_process) {
            post_location()
        }
    }

    function onClick_update() {
        if (var_can_process) {
            put_location()
        }
    }

    function onClick_delete() {
        set_deleteStatus('inactive');
        set_deleteLocation_open(true);
    }

    function onClick_cancel() {
        onClose();
    }

    function ChangeView() {
        const map = useMap();
        map.flyTo([51.505, -0.09], 16, {animate: true, duration: 4});
        return null;
    }

    function onClick_LatLon() {
        set_latlon_open(true)
    }

    function onClick_confirmDeleteLocation() {
        set_deleteStatus('processing')
        delete_location()
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='mdl_location'>

            <div className="modal__header">
                <div className='modal__header__text'>
                    <div className='text--md bold'>Location details</div>
                    <div className='text--sm color--gray--600'>Verify location details with Geoapify</div>
                </div>
            </div>

            <div className='modal__content'>

                <div className='location__details'>
                    {var_locationID !== 'ADD' &&
                        <div className='field__group'>
                            <CHIPS
                                label={'Reviewed'}
                                onChange={onChange_reviewed}
                                options={[
                                    {value: 'YES', text: 'Yes'},
                                    {value: 'NO' || null, text: 'No'},
                                ]}
                                value={var_data.reviewed === null ? 'NO' : var_data.reviewed}
                            />
                        </div>
                    }

                    {/*{var_locationID === 'ADD' &&*/}
                        <>
                            <div className='field__group'>
                                <CHIPS
                                    label={'Online'}
                                    onChange={onChange_online}
                                    options={[
                                        {value: 'YES', text: 'Yes'},
                                        {value: 'NO', text: 'No'},
                                    ]}
                                    value={var_data.online === null ? 'NO' : var_data.online}
                                />
                            </div>

                            {var_data.online !== 'YES' &&
                                <div className='field__group'>
                                    <CHIPS
                                        label={'City only'}
                                        onChange={onChange_cityOnly}
                                        options={[
                                            {value: 'YES', text: 'Yes'},
                                            {value: 'NO', text: 'No'},
                                        ]}
                                        value={var_data.cityonly === null ? 'NO' : var_data.cityonly}
                                    />
                                </div>
                            }
                        </>
                    {/*}*/}

                    {var_data.online !== 'YES' &&
                        <>
                            {var_data.cityonly !== 'YES' &&
                                <div className='field__group'>
                                    <INPUT
                                        errors={[]}
                                        label='Address'
                                        name='address'
                                        onChange={onChange_location}
                                        placeholder='Address'
                                        value={var_data.address || null}
                                    />
                                </div>
                            }

                            <div className='field__group'>
                                <INPUT
                                    errors={[]}
                                    label='City'
                                    name='city'
                                    onChange={onChange_location}
                                    placeholder='City'
                                    value={var_data.city || null}
                                />

                                <INPUT
                                    id='location_province'
                                    errors={[]}
                                    label='Province'
                                    maxLength='2'
                                    name='state'
                                    onChange={onChange_location}
                                    placeholder='Province'
                                    value={var_data.state || null}
                                />
                            </div>

                            <div className='field__group'>
                                <INPUT
                                    errors={[]}
                                    label='Country'
                                    name='country'
                                    onChange={onChange_location}
                                    placeholder='Country'
                                    value={'Canada'}
                                    disabled={true}
                                />
                            </div>
                        </>
                    }
                </div>

                {var_data.online !== 'YES' &&
                    <div className='location__map'>
                        <div className='field__label medium'>Location map</div>
                        {var_data.lat && var_data.lat ?
                            <MapContainer
                                attributionControl={false}
                                id='mapid'
                                className='mapimage'
                                center={[var_data.lat, var_data.lon]}
                                zoom={16}
                                scrollWheelZoom={false}
                                style={{height: "100%", width: "100%"}}
                            >
                                <TileLayer
                                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                                />
                                <Marker position={[var_data.lat, var_data.lon]} draggable={false} icon={var_marker}/>
                                {/*<ChangeView coords={[51.505, -0.09]} />*/}
                            </MapContainer>
                            :
                            <div className='mapimage--empty'>
                                {var_processing === 'inactive' && !var_data.lat &&
                                    <div className='mapimage--empty_inner'>
                                        <ICON name='location' className='icon' alt='warning icon'/>
                                        <div className='text_base'>A map cannot be displayed until the location's Lat/Lon has been added</div>
                                        <Button id='btn_latlon--new' className='tertiary' onClick={onClick_LatLon}>Add Lat/Lon</Button>
                                    </div>
                                }
                            </div>
                        }
                        <div id='location__latlon'>
                            {var_data.lat &&
                                <Button id='btn_latlon' className='tertiary' onClick={onClick_LatLon}>Update
                                    Lat/Lon</Button>
                            }
                            <div className='location__latlon__wrapper'>
                                <div className='text--sm bold'>Lat:</div>
                                <div className='text--sm'>{var_data.lat || '-'}</div>
                            </div>
                            <div className='location__latlon__wrapper'>
                                <div className='text--sm bold'>Lon:</div>
                                <div className='text--sm'>{var_data.lon || '-'}</div>
                            </div>
                            <div className='location__latlon__wrapper'>
                                <div className='text--sm bold'>Confidence:</div>
                                <div className='text--sm'>{var_data.geoapify_confidence || '-'}</div>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <PROCESSING state={var_processing}/>
            <div className='modal__footer'>
                <Button className={'primary' + (!var_can_process ? ' inactive' : '')}
                        onClick={var_locationID === 'ADD' ? onClick_add : onClick_update}>{var_locationID === 'ADD' ? 'Add' : 'Update'}</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
                {var_locationID !== 'ADD' &&
                    <Button id='btn_delete' className='tertiary' onClick={onClick_delete}>
                        <ICON name='garbage' className='icon' alt='garbage icon'/>
                        Delete location
                    </Button>
                }
            </div>

            <MDL_LATLON
                onOpen={var_latlon_open}
                onClose={() => set_latlon_open(false)}
                var_location={var_data}
                set_location={set_data}
                var_providerID={var_providerID}
            />

            <CMP_CONFIRMATION
                onOpen={var_deleteLocation_open}
                onClose={() => set_deleteLocation_open(false)}
                confirmation_state='warning'
                confirmation_title={'Delete location'}
                confirmation_subtitle='Confirmation required before proceeding'
                text={"Are you sure you want to delete this location?"}
                button_text='Delete'
                button_onClick={onClick_confirmDeleteLocation}
                processing_status={var_deleteStatus}
            />

        </Modal>

    );
}